export default "/_next/static/chunks/fonts/HK Grotesk Medium Italic-8d2bab6cc67142fbe08f710fb248cbe7.otf";